import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'shortNumber'
})
export class ShortNumberPipe implements PipeTransform {
  transform(value: number | null | undefined): string {
    if (value === null || value === undefined || isNaN(value)) return '0';
    if (value < 1000) return value.toString();

    const units = [
      { v: 1E3, s: "K" },
      { v: 1E6, s: "M" },
      { v: 1E9, s: "B" },
      { v: 1E12, s: "T" },
      { v: 1E15, s: "P" },
      { v: 1E18, s: "E" }
    ];

    let index = units.length - 1;
    while (index > 0 && value < units[index].v) {
      index--;
    }

    const shortValue = (value / units[index].v).toFixed(2).replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1");
    return shortValue + units[index].s;
  }
}
